"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function AutomaticCarWash(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "automatic-car-wash",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(15 16)",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("rect", {
    stroke: "#1437B9",
    "stroke-width": "32",
    fill: "#2CD5C4",
    fillRule: "nonzero",
    x: "65.99",
    y: "325.95",
    width: "349.98",
    height: "102.14",
    rx: "16.38"
  }), _react["default"].createElement("path", {
    d: "M379.38 325.11h-275l26.33-89.67A17.38 17.38 0 01147.35 223h189A17.37 17.37 0 01353 235.44l26.38 89.67z",
    stroke: "#1437B9",
    "stroke-width": "32",
    fill: "#FFF",
    fillRule: "nonzero"
  }), _react["default"].createElement("rect", {
    stroke: "#1437B9",
    "stroke-width": "32",
    fill: "#FFF",
    fillRule: "nonzero",
    x: "104.61",
    y: "428.09",
    width: "83.75",
    height: "52.81",
    rx: "3.76"
  }), _react["default"].createElement("rect", {
    stroke: "#1437B9",
    "stroke-width": "32",
    fill: "#FFF",
    fillRule: "nonzero",
    x: "295.84",
    y: "428.09",
    width: "83.75",
    height: "52.81",
    rx: "3.76"
  }), _react["default"].createElement("path", {
    stroke: "#1437B9",
    "stroke-width": "32",
    "stroke-linecap": "round",
    d: "M402.89 325.95H79.11M.45 480.88v-469c0-6.075 4.925-11 11-11L469.54.06c6.075 0 11 4.925 11 11V481"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M68.54 58.89h347.43v103.08H68.54z"
  }), _react["default"].createElement("path", {
    fill: "#2CD5C4",
    fillRule: "nonzero",
    d: "M415.97 166.97V58.89l-17.73 1.51-80.45 109.58zM76.57 167.72l117.72 1.26L274.74 59.4l-117.73-1.27z"
  }), _react["default"].createElement("rect", {
    stroke: "#1437B9",
    "stroke-width": "32",
    x: "63.54",
    y: "58.89",
    width: "352.43",
    height: "108.08",
    rx: "5"
  }), _react["default"].createElement("path", {
    d: "M157 58.13L76.57 167.72 157 58.13zM194.29 169l80.45-109.6L194.29 169zM318.35 169L398.8 59.4 318.35 169zM63.54 114.43H1.45M481.54 114.43h-62.09",
    stroke: "#1437B9",
    "stroke-width": "32"
  }))));
}

AutomaticCarWash.defaultProps = {
  size: 30
};
var _default = AutomaticCarWash;
exports["default"] = _default;